"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsInitializationPlugin = void 0;
const analytics_service_1 = require("./analytics-service");
const analytics_service_factory_1 = require("./analytics-service-factory");
const DEFAULT_CATEGORY = 'Default category';
class AnalyticsVueService extends analytics_service_1.AnalyticsService {
    constructor(Vue, analyticsOptions) {
        super(analyticsOptions);
        this.categoryFromRouteMeta = '';
        const self = this;
        const vueMixin = {
            beforeRouteEnter(to, from, next) {
                self.categoryFromRouteMeta = to.meta.analyticEventCategory ? to.meta.analyticEventCategory : DEFAULT_CATEGORY;
                next();
            },
            created() {
                if (!self.categoryFromRouteMeta || self.categoryFromRouteMeta === DEFAULT_CATEGORY) {
                    const analyticEventCategory = this.$route && this.$route.meta && this.$route.meta.analyticEventCategory;
                    self.categoryFromRouteMeta = analyticEventCategory ? analyticEventCategory : DEFAULT_CATEGORY;
                }
            }
        };
        Vue.mixin(vueMixin);
    }
    trackEvent(eventName, category, properties) {
        if (!category) {
            category = this.categoryFromRouteMeta;
        }
        super.trackEvent(eventName, category, properties);
    }
}
exports.AnalyticsInitializationPlugin = {
    install(Vue, options) {
        const analyticsService = new AnalyticsVueService(Vue, options);
        analytics_service_factory_1.AnalyticsServiceFactory.initialize(analyticsService);
    }
};
